import React from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import "./MessageCard.css";

const MessageCard = ({ type = "info", message }) => {
  return (
    <div className={`message-card ${type}`}>
      <InfoOutlinedIcon className="message-icon" />
      <span className="message-text">{message}</span>
    </div>
  );
};

export default MessageCard;